var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_17_318",
    transform: "scale(0.0434783)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_17_318",
    width: 23,
    height: 23,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAACPElEQVRIia2VX2jNYRjHPzabbf5koVZqF/5lbsgFYsudkrT8iYaRG3IlmptJ4sqNtJQ7rbjcrkRxQWdozZ9CVlsKnbgSo2SU9NGr9+jdb+dsZ+ytp9Pz5/2e53ne7/P8UAuyTb2vvlSPJvZ/lsLFLvWxuledr35Um6YDfLeaU2cnji3qvRKXKtUGdWY54E+LZFmh3lIPF7m0SL2u3oi/2ycC/1nCWaOOqo0l/LPUg+oD9apal42pAL4DVYw/P4DVQBdQmXgXAJeATqAPaAHqgJ4sQgDvjyDFzkbgV8b+FbgGjAI3gQ6gDagBToyJjAw5V6TkK+rDyJ7UNyeSoDb6htW26BtO40PmvcAmoDb5zwPAXKAZ+JLJvDq24hGwElgLnIyt643637aEsvPAhgTgG/C6RKtGgONAO3Ahvtkg0AgMjGlxLCFQ8V1SeuD8iwmYEqRaPR15364uVlepO1MqFuS82pPoLernIj2f0oSm8kTdkejH1Ofx8f4bfIn6SV0R9RnqRbV/OsCDNKsj6vLEdjkutoVF4s+o3eqycsCD7FLfq/UZkCF1fWI7pQ6oZ9VnUa+cDDzIEfWtujSx7VMH44oODMkn2zRU2qfeje2dEJw4eaGCNYmtIU5vYNa6THyV2hFJ0FbOw7Sqb9T9U3jMUO2rcoOb4lB1x+wmiw/UzVWUGPHsGQI2R2MOODRJfFgPuSlzV92q3lbvqJ3xPQrVzItE+BA+NmFIykx+3NkDtMbtWdj5oRP1f5Ya5H8D+lbxTW+ID6wAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.b1726929c9bd2263962e3befd3add82d.svg";
export { ForwardRef as ReactComponent };